module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_113-bffb17b914d791c10ac4802a89423b16.png";